import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noAdminPermissionMessage: {
		defaultMessage:
			'You do not have access to Jira settings or Atlassian admin, {contact} to grant you access.',
		id: 'atlassian-navigation.settings.menu.warning.no-admin-permission-message',
		description: 'The message shows when user does not have permission to view the admin sections',
	},
	noAdminPermissionMessageContact: {
		defaultMessage: 'contact your Jira admin',
		id: 'atlassian-navigation.settings.menu.warning.no-admin-permission-message-contact',
		description: 'The sub message that links to contact admin',
	},
});
